// dependencies
import React from "react";
import { List } from "immutable";
import PropTypes from "prop-types";
import { connect } from "react-redux";

// components
import { NotificationStack } from "react-notification";

// actions
import { dismissNotification } from "Actions/notifications";

// selectors
import { getNotifications } from "Selectors/notifications";

// css
import css from "./Notifications.styl";

class Notifications extends React.PureComponent {
	static propTypes = {
		dismissNotification: PropTypes.func.isRequired,
		notifications: PropTypes.instanceOf(List).isRequired,
	};

	onDismissNotification = (notification) => {
		this.props.dismissNotification(notification.key);
	};

	handleDismissNotification = (notification) => {
		this.props.dismissNotification(notification.key);
	};

	render = () => {
		const { notifications } = this.props;
		const notificationsJS = notifications.toJS();

		notificationsJS.forEach((n) => {
			const notification = n;

			notification.barStyle = {
				borderRadius: 3,
				padding: 20,
				width: 300,
				boxStyle: "border-box",
				font: '1em normal "Proxima Nova", Georgia, sans-serif',
				...notification.barStyle,
			};

			notification.actionStyle = {
				borderRadius: 2,
				padding: 0,
				marginLeft: 0,
				height: 30,
				width: 90,
				fontWeight: 600,
				lineHeight: "30px",
				letterSpacing: "auto",
				textAlign: "center",
				...notification.actionStyle,
			};

			notification.onClick = (notificationRef, deactivate) => {
				deactivate();
				this.handleDismissNotification(notificationRef);
			};
		});

		return (
			<div className={css.Notifications}>
				<NotificationStack notifications={notificationsJS} onDismiss={this.onDismissNotification} />
			</div>
		);
	};
}

const mapStateToProps = (state) => ({
	notifications: getNotifications(state),
});

const mapDispatchToProps = (dispatch) => ({
	dismissNotification: (notificationID) => dispatch(dismissNotification(notificationID)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);
